import { render, staticRenderFns } from "./posterSimple.vue?vue&type=template&id=9587dd9e&scoped=true"
import script from "./posterSimple.vue?vue&type=script&lang=js"
export * from "./posterSimple.vue?vue&type=script&lang=js"
import style0 from "./posterSimple.vue?vue&type=style&index=0&id=9587dd9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9587dd9e",
  null
  
)

export default component.exports